import React, { useState } from 'react'
import { useParams } from 'react-router-dom';
import UseGetData from '../../../hooks/useFetchData';
import { GetAccess } from '../../../utils/RolesandAccess';
import { AddIcon } from '../../../assets/icons';
import ViewMore from './viewMore';
import { TableLoader } from '../../../components/Loader';
import CreateorUpdate from './form';

function EmailTemplateIndex() {
    const {stdId} = useParams();
    const { data, getData, isLoading } = UseGetData({ url: `/email_templates/standard/${stdId}` });
    const [showMyModal, setShowMyModal] = useState(false);
  return (
    <>
    <div className=" w-full h-[calc(100vh-140px)] overflow-y-auto">
      <div className="pb-2 px-2 flex justify-between items-center w-full">
        <h4 className="text-sm 2xl:text-base font-medium text-heading">
         Email Templates
        </h4>
        <div className=" w-8 flex justify-center items-center cursor-pointer">
          {GetAccess("admin_create") && (
            <div onClick={() => setShowMyModal(true)}>
              <AddIcon />
            </div>
          )}
        </div>
      </div>
      <div className=" w-full h-[calc(100vh-180px)]  relative overflow-y-auto">
          <div className=" sticky top-0 z-10">
            <table className="table-auto w-full">
              <thead className="bg-tabletitle">
                <tr className="flex items-center text-xs 2xl:text-sm font-medium">
                  {header?.map((header) => (
                    <th
                      className={`text-center py-4 font-medium ${header.width}`}
                    >
                      {header?.headone}
                    </th>
                  ))}
                </tr>
              </thead>
            </table>
          </div>
          <div>
            <table className="table-auto w-full">
              {isLoading == true ? (
                <>
                  {[...Array(8)].map((_, index) => {
                    return <TableLoader key={index} header={header} />;
                  })}
                </>
              ) : (
                <>
                  {data &&
                    data.map((data, i) => (
                      <tr
                        className="odd:bg-tableodd w-full even:bg-tableeven text-xs 2xl:text-sm py-1 flex justify-between items-center my-1"
                        key={i}
                      >
                        <td
                          className={`text-center px-5 text-gray-900 py-1 w-[5%]`}
                        >
                          {data.serial_number || "#"}
                        </td>
                      <td className="text-left text-gray-900 w-[20%] px-2 py-1">
                        {data.status_name == "completed" ? "Completed"
                         :data.status_name == "in progress"? "In Progress"
                         :data.status_name == "yet to start"? "Yet to Start"
                         :data.status_name == "review_and_approved"? "Reviewed and Approved"
                         :data.status_name == "reminder"? "Reminder"
                         :data.status_name == "one month alert"? "Standard Expiry Alert Before One Month"
                         :data.status_name == "one week alert"? "Standard Expiry Alert Before One Week"
                         :data.status_name == "one day before alert"? "Standard Expiry Alert Before One Day"
                         :data.status_name == "after one day alert"? "Standard Expiry Alert After One Day"
                         :data.status_name== "Standard Reset"? "Standard Reset"
                         :""
                         || "-"}
                      </td>
                      <td className="text-left text-gray-900 w-[30%] px-3 py-1">
                        {data.subject|| "-"}
                      </td>
                      <td className=" text-justify text-gray-900 w-[40%] px-3 py-1">
                        {data.message|| "-"}
                      </td>
                      <td className=" w-[5%]">
                      <div className=" w-full h-full flex justify-center items-center">
                            <ViewMore data={data} fetcher={getData} />
                          </div>
                      </td>
                      </tr>
                    ))}
                </>
              )}
            </table>
          </div>
        </div>
      </div>
    <CreateorUpdate
      onClose={() => setShowMyModal(false)}
      visible={showMyModal}
      refreshData={getData}
    />
    </>
  )
}

export default EmailTemplateIndex;


const header = [
    {
      headone: "Sl.No",
      width: "w-[5%]",
    },
    {
      headone: "Status",
      width: "w-[20%]",
    },
    {
      headone: "Subject",
      width: "w-[25%]",
    },
    {
      headone: "Message",
      width: "w-[45%]",
    },
    {
      headone: " ",
      width: "w-[5%]",
    }
  ];